import './HeroSection.css';
import { BOOK_DEMO_URL } from '../../constants/urls';
import mainReviewImg from '../../assets/main_review.svg';
import fieldEdgeLogo from '../../assets/crmLogos/field_edge.png';
import housecallProLogo from '../../assets/crmLogos/housecall_pro.png';
import hubSpotLogo from '../../assets/crmLogos/hub_spot.png';
import jobberLogo from '../../assets/crmLogos/jobber.png';
import salesforceLogo from '../../assets/crmLogos/salesforce.png';
import serviceFusionLogo from '../../assets/crmLogos/service_fusion.png';
import titanServiceLogo from '../../assets/crmLogos/titan_service.png';
import zohoLogo from '../../assets/crmLogos/zoho.png';
import quickbooksOnlineLogo from '../../assets/crmLogos/intuit_quick_books.png';
import pipedriveLogo from '../../assets/crmLogos/pipe_drive.png';
import builderPrimeLogo from '../../assets/crmLogos/builder_prime.png';
import fieldBossLogo from '../../assets/crmLogos/field_boss.png';

const CRM_LOGOS = [
  { name: 'Housecall Pro', src: housecallProLogo },
  { name: 'HubSpot', src: hubSpotLogo },
  { name: 'Salesforce', src: salesforceLogo },
  { name: 'Zoho', src: zohoLogo },
  { name: 'Field Boss', src: fieldBossLogo },
  { name: 'Service Fusion', src: serviceFusionLogo },
  { name: 'FieldEdge', src: fieldEdgeLogo },
  { name: 'Titan Service', src: titanServiceLogo },
  { name: 'Quickbooks Online', src: quickbooksOnlineLogo },
  { name: 'PipeDrive', src: pipedriveLogo },
  { name: 'Builder Prime', src: builderPrimeLogo },
  { name: 'Jobber', src: jobberLogo },
  { name: 'Housecall Pro', src: housecallProLogo },
  { name: 'HubSpot', src: hubSpotLogo },
  { name: 'Salesforce', src: salesforceLogo },
  { name: 'Zoho', src: zohoLogo },
  { name: 'Field Boss', src: fieldBossLogo },
  { name: 'Service Fusion', src: serviceFusionLogo },
  { name: 'FieldEdge', src: fieldEdgeLogo },
  { name: 'Titan Service', src: titanServiceLogo },
  { name: 'Quickbooks Online', src: quickbooksOnlineLogo },
  { name: 'PipeDrive', src: pipedriveLogo },
  { name: 'Builder Prime', src: builderPrimeLogo },
  { name: 'Jobber', src: jobberLogo },
] as const;

const CRM_LOGOS_MARQUEE = [...CRM_LOGOS, ...CRM_LOGOS];

const DARK_CRM_LOGOS = new Set(['Field Boss', 'Service Fusion']);

export function HeroSection() {
  return (
    <section className="hero" aria-labelledby="hero-heading">
      <div className="container hero__layout">
        <div className="hero__grid">
          <div className="hero__content">
            <h1 id="hero-heading" className="hero__title">
              <span className="hero__badge">Review Automation</span>
              <span className="hero__headline">for Home Service Businesses</span>
            </h1>
            <p className="hero__subtitle">
              Start Getting the Reviews You Deserve. Start Ranking Higher On Google.
              Start Getting Chosen Over Your Competition.
            </p>
            <div className="hero__ctas">
              <a href="#pricing" className="btn btn--primary btn--lg">
                Start getting reviews
              </a>
              <a
                href={BOOK_DEMO_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn--secondary btn--lg"
              >
                Book a demo
              </a>
            </div>
          </div>

          <div className="hero__media-wrap">
            <div className="hero__media-bg" aria-hidden="true" />
            <div className="hero__media">
              <img
                src={mainReviewImg}
                alt="Review Lumen dashboard with customer reviews and ratings"
                className="hero__media-image"
              />
            </div>
          </div>
        </div>

        <div className="hero__crm" aria-labelledby="trusted-heading">
          <h2 id="trusted-heading" className="hero__crm-heading">
            Easily connect to your existing CRM
          </h2>
          <div className="trusted__marquee" aria-label="CRM integrations">
            <ul className="trusted__marquee-track">
              {CRM_LOGOS_MARQUEE.map((logo, index) => (
                <li
                  key={`${logo.name}-${index}`}
                  className={`trusted__logo-item${
                    DARK_CRM_LOGOS.has(logo.name) ? ' trusted__logo-item--dark' : ''
                  }`}
                >
                  <img src={logo.src} alt={logo.name} loading="lazy" />
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
